import { InputBase, type InputBaseProps } from '@mantine/core';
import { IMaskInput } from 'react-imask';

const regex = /^[+\-()0-9 ]*$/;

export type PhoneInputProps = {
  value?: string;
  onChange: (value: string) => void;
  onBlur?: () => void;
  placeholder?: string;
  mask?: string;
} & InputBaseProps;

export const PhoneInput = ({
  value,
  onChange,
  onBlur,
  placeholder,
  mask,
  ...props
}: PhoneInputProps) => {
  const handleAccept = (value: string) => {
    if (!regex.test(value)) {
      return;
    }

    const cleanValue = value.replace(/\D/g, '');

    onChange(cleanValue);
  };

  return (
    <InputBase
      {...props}
      value={value || ''}
      onBlur={onBlur}
      component={IMaskInput}
      mask={mask || '+0 (000) 000-0000'}
      onAccept={handleAccept}
      placeholder={placeholder}
    />
  );
};
